module.exports = __webpack_public_path__ + "static/img/3.317ba7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/3.png
// module id = R0PW
// module chunks = 4